module.exports = __webpack_public_path__ + "img/image (1).74242749.png";